module.exports = __webpack_public_path__ + "static/img/v002.281f71b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/old_sites/v002.png
// module id = v9fY
// module chunks = 1